import React from 'react';
import { Box, Typography } from '@mui/material';
import { computeGstTotals, formatINR } from '../../utils/gstTotals';

const Row = ({ label, value, bold }) => (
  <Box display="flex" justifyContent="space-between" gap="40px" sx={{ py: '4px' }}>
    <Typography sx={{ fontSize: bold ? '18px' : '14px', fontWeight: bold ? 600 : 400, color: bold ? '#1A1A1A' : '#4D4D4D' }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize: bold ? '18px' : '14px', fontWeight: bold ? 600 : 500, color: '#1A1A1A' }}>
      {value}
    </Typography>
  </Box>
);

// Sub total, 18% GST and grand total for a list of quoted parts
const GstSummary = ({ parts }) => {
  const { subTotal, gst, grandTotal } = computeGstTotals(parts);
  return (
    <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
      <Box sx={{ minWidth: '280px' }}>
        <Row label="Sub Total" value={formatINR(subTotal)} />
        <Row label="GST (18%)" value={formatINR(gst)} />
        <Box sx={{ borderTop: '1px solid #E6E6E6', mt: '4px', pt: '4px' }}>
          <Row label="Grand Total" value={formatINR(grandTotal)} bold />
        </Box>
      </Box>
    </Box>
  );
};

export default GstSummary;
